"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllRegistriesInfo = exports.GET_REGISTRIES = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../config");
exports.GET_REGISTRIES = `
  query getRegistries {
    masters {
      address
      withdrawPeriod
      safetyPeriod
    }
  }
`;
const getAllRegistriesInfo = async () => {
    try {
        const subgraphsRequests = Object.values(config_1.ChainsConfig).map((chain) => {
            return axios_1.default.post(chain.subgraph, JSON.stringify({
                query: exports.GET_REGISTRIES,
            }), {
                headers: {
                    "Content-Type": "application/json",
                },
            });
        });
        const subgraphsResponses = await Promise.all(subgraphsRequests);
        const subgraphsData = subgraphsResponses.map((res) => res.data);
        const registries = [];
        for (let i = 0; i < subgraphsData.length; i++) {
            const chainId = Object.values(config_1.ChainsConfig)[i].chain.id;
            if (!subgraphsData[i].data || !subgraphsData[i].data.masters)
                continue;
            for (const registry of subgraphsData[i].data.masters) {
                const withdrawPeriod = +registry.withdrawPeriod;
                const safetyPeriod = +registry.safetyPeriod;
                const secondsInPeriod = (Date.now() / 1000) % (withdrawPeriod + safetyPeriod);
                let nextSafetyPeriod;
                let isSafetyPeriod = false;
                if (secondsInPeriod >= withdrawPeriod) {
                    nextSafetyPeriod = safetyPeriod + withdrawPeriod * 2 - secondsInPeriod;
                    isSafetyPeriod = true;
                }
                else {
                    nextSafetyPeriod = withdrawPeriod - secondsInPeriod;
                }
                registries.push({
                    address: registry.address,
                    safetyPeriod,
                    withdrawPeriod,
                    nextSafetyPeriod,
                    isSafetyPeriod,
                    chainId,
                });
            }
        }
        return registries;
    }
    catch (error) {
        return [];
    }
};
exports.getAllRegistriesInfo = getAllRegistriesInfo;
